module.exports = __webpack_public_path__ + "img/diamonds@2x.a22cd32.webp";